import { Badge } from "@/components/ui/badge";

export function UtteranceTags({ tags }: { tags: string[] }) {
  if (!tags || tags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-1">
      {tags.map((t, i) => (
        <Badge key={i} variant="secondary" className="text-xs">
          {t}
        </Badge>
      ))}
    </div>
  );
}
